import _toConsumableArray from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../../assets/img/logo-UPS.png';
import _imports_1 from '../../assets/img/icon-id.png';
import _imports_2 from '../../assets/img/icon-email.png';
import _imports_3 from '../../assets/img/icon_user.png';
import _imports_4 from '@/assets/img/customer/success@2x.png';
import _imports_5 from '@/assets/img/customer/jiantou_hui@2x.png';
import _imports_6 from '@/assets/img/customer/jiantou@2x.png';
import _imports_7 from '@/assets/img/customer/upload-close@2x.png';
var _hoisted_1 = {
  class: "ups-header--container"
};
var _hoisted_2 = {
  class: "ups-header--left"
};
var _hoisted_3 = {
  class: "ups-header__title"
};
var _hoisted_4 = {
  class: "ups-header--right"
};
var _hoisted_5 = {
  class: "ups-header--right-name"
};
var _hoisted_6 = {
  class: "right-staff"
};
var _hoisted_7 = {
  class: "ups-header--right-email"
};
var _hoisted_8 = {
  class: "right-staff"
};
var _hoisted_9 = {
  key: 1,
  class: "ups-header__user"
};
var _hoisted_10 = {
  key: 2,
  class: "ups-header__department"
};
var _hoisted_11 = {
  key: 3,
  class: "vertical-line"
};
var _hoisted_12 = {
  class: "ups-header__department"
};
var _hoisted_13 = {
  class: "flex-info"
};
var _hoisted_14 = {
  class: "success_p"
};
var _hoisted_15 = {
  class: "has-upload_content flex-info"
};
var _hoisted_16 = {
  key: 0
};
var _hoisted_17 = {
  key: 0,
  src: _imports_5,
  class: "detail-icon"
};
var _hoisted_18 = {
  key: 1,
  src: _imports_6,
  class: "detail-icon"
};
var _hoisted_19 = {
  class: "btm_info"
};
var _hoisted_20 = {
  class: "drawer-details"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_popover = _resolveComponent("el-popover");
  var _component_Upload = _resolveComponent("Upload");
  var _component_el_icon = _resolveComponent("el-icon");
  var _component_el_badge = _resolveComponent("el-badge");
  var _component_el_tooltip = _resolveComponent("el-tooltip");
  var _component_UploadHistoryDialog = _resolveComponent("UploadHistoryDialog");
  var _component_el_drawer = _resolveComponent("el-drawer");
  var _component_ResultDialog = _resolveComponent("ResultDialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "ups-header__logo"
  }, null, -1)), _createElementVNode("h1", _hoisted_3, _toDisplayString($data.title), 1)]), _createElementVNode("div", _hoisted_4, [$props.isAdmin ? (_openBlock(), _createBlock(_component_el_popover, {
    key: 0,
    modelValue: $data.isShowProfile,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.isShowProfile = $event;
    }),
    placement: "bottom",
    title: "",
    width: "250px",
    trigger: "click",
    "popper-class": "ups-header-popover"
  }, {
    reference: _withCtx(function () {
      return _toConsumableArray(_cache[11] || (_cache[11] = [_createElementVNode("img", {
        src: _imports_3,
        class: "ups-header--right-img"
      }, null, -1)]));
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_5, [_cache[7] || (_cache[7] = _createElementVNode("img", {
        class: "icon righr-img",
        src: _imports_1
      }, null, -1)), _cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "righr-label"
      }, "员工ID", -1)), _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userinfo.userName), 1)]), _createElementVNode("div", _hoisted_7, [_cache[9] || (_cache[9] = _createElementVNode("img", {
        class: "icon righr-img",
        src: _imports_2
      }, null, -1)), _cache[10] || (_cache[10] = _createElementVNode("span", {
        class: "righr-label"
      }, "邮箱", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.userinfo.staffEmail), 1)])];
    }),
    _: 1
  }, 8, ["modelValue"])) : (_openBlock(), _createElementBlock("div", _hoisted_9, _toConsumableArray(_cache[12] || (_cache[12] = [_createElementVNode("img", {
    src: _imports_3,
    class: "ups-header--right-img"
  }, null, -1)])))), $props.isAdmin ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.userinfo.userName), 1)) : _createCommentVNode("", true), $props.isAdmin ? (_openBlock(), _createElementBlock("span", _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.userinfo.department), 1), _cache[14] || (_cache[14] = _createElementVNode("span", {
    class: "vertical-line"
  }, null, -1)), _createElementVNode("span", {
    class: "upload-icon",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.showDrawerFunc && $options.showDrawerFunc.apply($options, arguments);
    })
  }, [_createVNode(_component_el_tooltip, {
    class: "item-tooltip",
    effect: "dark",
    placement: "bottom"
  }, {
    content: _withCtx(function () {
      return _toConsumableArray(_cache[13] || (_cache[13] = [_createElementVNode("div", {
        class: "item-tooltip-content"
      }, [_createElementVNode("div", {
        class: "item-tooltip-label"
      }, "上传模板详情"), _createElementVNode("div", {
        class: "item-tooltip-data"
      }, "查看上传文件历史数据")], -1)]));
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_badge, {
        value: $data.unconfirmValue,
        max: 9,
        hidden: $data.unconfirmValue === 0,
        class: "item"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_Upload)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["value", "hidden"])];
    }),
    _: 1
  })]), _cache[15] || (_cache[15] = _createElementVNode("span", {
    class: "vertical-line"
  }, null, -1)), _createElementVNode("span", {
    class: "ups-header__logout",
    type: "text",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.logout && $options.logout.apply($options, arguments);
    })
  }, "退出")]), $data.hasUploadShow ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass({
      'has-upload': true,
      'has-upload-draft': $options.isDraft
    })
  }, [_createElementVNode("div", _hoisted_13, [_cache[18] || (_cache[18] = _createElementVNode("img", {
    src: _imports_4,
    class: "success-icon"
  }, null, -1)), _createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("div", {
    class: "success-text"
  }, "上传完成！", -1)), _createElementVNode("p", _hoisted_14, _toDisplayString($options.getTotalString()), 1), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [$data.detailInfo.isFixed || $data.detailInfo.isRowData ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString("\u6210\u529F\u65B0\u589E".concat($data.detailInfo.ticketSuccess, "\u7968\u62A5\u5173\u5355\uFF0C")), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, "成功新增" + _toDisplayString($data.detailInfo ? $data.detailInfo.success : 0) + _toDisplayString($data.unit) + "，重复上传" + _toDisplayString($data.detailInfo ? $data.detailInfo.repeat : 0) + _toDisplayString($data.unit) + "，", 1), _createElementVNode("strong", null, "异常" + _toDisplayString($data.detailInfo ? $data.detailInfo.abnormal : 0) + _toDisplayString($data.unit), 1)]), _createElementVNode("div", {
    class: _normalizeClass(["flex-info detail-btn", {
      'flex-info detail-btn-disable': $data.detailInfo.abnormal === 0 && $data.detailInfo.repeat === 0
    }])
  }, [_createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = function () {
      return $options.gotoDetail && $options.gotoDetail.apply($options, arguments);
    })
  }, "查看结果"), $data.detailInfo.abnormal === 0 && $data.detailInfo.repeat === 0 ? (_openBlock(), _createElementBlock("img", _hoisted_17)) : (_openBlock(), _createElementBlock("img", _hoisted_18))], 2)]), _createElementVNode("div", _hoisted_19, [_createTextVNode("您有" + _toDisplayString($data.unconfirmValue) + "条上传结果未查看，请点击", 1), _createElementVNode("span", {
    onClick: _cache[4] || (_cache[4] = function () {
      return $options.showHistory && $options.showHistory.apply($options, arguments);
    })
  }, "上传历史记录"), _cache[16] || (_cache[16] = _createTextVNode("进行查看", -1))])])]), _createElementVNode("img", {
    class: "has-upload_close",
    src: _imports_7,
    onClick: _cache[5] || (_cache[5] = function () {
      return $options.hasUploadClose && $options.hasUploadClose.apply($options, arguments);
    })
  })], 2)) : _createCommentVNode("", true), _createVNode(_component_el_drawer, {
    "model-value": $data.showDrawer,
    title: "批量创建记录",
    direction: "rtl",
    onClosed: $options.drawerClosed
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_20, [$data.showDrawer ? (_openBlock(), _createBlock(_component_UploadHistoryDialog, {
        key: 0,
        ref: "UploadHistoryDialog",
        "show-drawer": $data.showDrawer,
        onChangeShowDrawer: $options.changeShowDrawer
      }, null, 8, ["show-drawer", "onChangeShowDrawer"])) : _createCommentVNode("", true)])];
    }),
    _: 1
  }, 8, ["model-value", "onClosed"]), _createVNode(_component_ResultDialog, {
    ref: "resultDialogRef"
  }, null, 512)]);
}